var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// react/heart-16.js
import React from "react";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/heart/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.heart":"Hjerte"}');

// src/raw/heart/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.heart":"Heart"}');

// src/raw/heart/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.heart":"Syd\xE4n"}');

// src/raw/heart/locales/da/messages.mjs
var messages4 = JSON.parse('{"icon.title.heart":"Hjerte"}');

// src/raw/heart/locales/sv/messages.mjs
var messages5 = JSON.parse('{"icon.title.heart":"Hj\xE4rta"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages6 = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages6);
  i18n.activate(locale);
};

// react/heart-16.js
activateI18n(messages2, messages, messages3, messages4, messages5);
var title = i18n2.t({ message: `Heart`, id: "icon.title.heart", comment: "Title for heart icon" });
var IconHeart16 = (attrs) => React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-width="1.5" d="M7.98 14c.386 0 .604-.318 1.226-.939.776-.777 1.525-1.5 2.069-2.045 1.605-1.605 2.236-2.215 2.684-2.69 1.191-1.263 1.345-3.019.538-4.351C13.48 2.295 11.961 2 11.145 2s-1.4.295-2.43 1.054l-.716.631-.695-.63C6.186 2.152 5.376 2 4.856 2c-.433 0-2.244 0-3.41 1.975-.851 1.44-.406 3.215.678 4.351.194.203.994.994 2.383 2.417.559.573 1.35 1.361 1.933 1.96C6.77 13.042 7.595 14 7.98 14Z" clip-rule="evenodd"></path>` } }, attrs));
var heart_16_default = IconHeart16;
export {
  IconHeart16,
  heart_16_default as default
};
//# sourceMappingURL=heart-16.js.map
